<template>
  <div class="base-image" ref="box">
    <div class="base-image_box">
      <img
        class="base-image_image"
        :src="image"
        :alt="alt"
        :id="`${stepNumber}-wfimage-${src.imageKey}`"
        ref="image"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseImage',
  props: {
    src: {
      type: Object,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    ratio: {
      type: Number,
      default: 6/11,
    },
    stepNumber: {
      type: Number,
    }
  },
  mounted() {
    const ratio = (this.ratio * 100).toFixed(2);
    this.$refs.box.style.setProperty('--box-ratio', `${ratio}%`);
    this.$refs.image.style.setProperty('--mobile-image-url', `url(${this.mobileImage})`);
  },
  computed: {
    image() {
      return this.src.image.replace(/ /g, '%20');
    },
    mobileImage() {
      return this.src.mobileImage.replace(/ /g, '%20');
    }
  }
};
</script>
<style lang="scss" scoped>
  .base-image {
    width: 100%;
    position: relative;
    &:after {
      content: '';
      display: block;
      padding-top: var(--box-ratio, 54.54%);
    }
    .base-image_box {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
        .base-image_image {
          @media(max-width: $mobile) {
            content: var(--mobile-image-url);
          }
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
    }
  }
</style>
